export default __webpack_public_path__ + "static/media/emotion.af3d9196.png";